import React from 'react';
import Edit from '../../../containers/rest/Edit';
import Form from '../components/Form';

const DealpipelinesEdit = props => (
  <Edit {...props} resource="dealpipelines">
    <Form />
  </Edit>
);

DealpipelinesEdit.propTypes = {};

export default DealpipelinesEdit;
